/*
 * Animation for the sub menus
 * @param {HTMLelement} arrowIcon
 */
raymont.dropdown = function(arrowIcon){
    
    var subMenuContainer = arrowIcon.siblings('.sub-menu');
        parentLink = arrowIcon.parent(),
        allDropdownOpened = $('.open');
        
    // Close all dropdowns already opened
    if(parentLink.parent().hasClass('menu') && (parentLink.attr('id') != (allDropdownOpened.attr('id'))) ){
       
        allDropdownOpened.each( function(){
                $(this).removeClass('open');
                $(this).children('.sub-menu').animate({
                    height: 'toggle'
                }, 200);
            })
    }
    
    // Toggle dropdowns
    if(parentLink.hasClass('open')){
        parentLink.removeClass('open');

        subMenuContainer.animate({
            height: 'toggle'
        }, 200);

    } else {
        parentLink.addClass('open');

        subMenuContainer.animate({
            height: 'toggle'
        }, 200);
    } 
    
};